module.exports = __webpack_public_path__ + "img/edenred-comliments.37488ccd.png";